import React, { Component } from 'react';
import AuthHelper from '@youfy/shared/helpers/AuthHelper';
import UserApi from '../api/user';

const AuthContext = React.createContext({});

export class AuthProvider extends Component {
  state = {
    loading: true,
    authenticating: false,
    isAuthenticated: false,
    token: AuthHelper.getToken(),
    session: AuthHelper.getSession(),
    me: {},
    company: null,
    error: null,
  };

  isAuthorized(resource) {
    const resources = Array.isArray(resource) ? resource : [resource];

    const { me } = this.state;
    const user_resources = me.resources || [];
    const hasResource = user_resources.some(item => resources.includes(item.toUpperCase()));
    return hasResource || me.is_admin || me.is_holder;
  }

  async fetchData() {
    const session = AuthHelper.getSession();

    if (session.sub) {
      try {
        const me = await UserApi.getMe(session.sub);
        const company = me.company;
        AuthHelper.setCompany(company.id);
        this.setState({ me, isAuthenticated: !!me.id, loading: false, company });
      } catch (error) {
        const response = error.response || {};

        if ([404, 401].includes(response.status)) {
          AuthHelper.clearToken();
        }

        this.setState({ isAuthenticated: false, loading: false, error });
      }
    } else {
      this.setState({ isAuthenticated: false, loading: false });
    }
  }

  signIn(data) {
    AuthHelper.setToken(data);
    this.setState({ me: data.user, isAuthenticated: !!AuthHelper.getToken(), token: AuthHelper.getToken(), session: AuthHelper.getSession() });
  }

  signOut() {
    AuthHelper.clearToken();
    this.setState({ isAuthenticated: false, token: null, session: {} });
  }

  render() {
    const { children } = this.props;
    const { token, isAuthenticated, session, authenticating, loading, me } = this.state;
    const { signIn, signOut, fetchData, isAuthorized } = this;

    const providerValue = {
      isAuthenticated,
      loading,
      authenticating,
      token,
      session,
      me,
      signIn: signIn.bind(this),
      signOut: signOut.bind(this),
      fetchData: fetchData.bind(this),
      isAuthorized: isAuthorized.bind(this),
    };

    return <AuthContext.Provider value={providerValue}>{children}</AuthContext.Provider>;
  }
}

export const useAuth = () => React.useContext(AuthContext);
export default AuthContext;
